import { render } from "./RCFileUpload.vue?vue&type=template&id=62a54602"
import script from "./RCFileUpload.vue?vue&type=script&lang=js"
export * from "./RCFileUpload.vue?vue&type=script&lang=js"

import "./RCFileUpload.vue?vue&type=style&index=0&id=62a54602&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__